import { genericMemo } from "@redotech/react-util/component";
import { BooleanEvaluationExpression } from "@redotech/redo-flows-core-schema-common/expressions/boolean-expression";
import { Schema } from "@redotech/redo-flows-core-schema-common/type-system/schema";
import { useTranslation } from "@redotech/redo-i18n";
import { TextRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { DeepPartial, DeepPartialExcept } from "@redotech/util/type";
import { useEffect } from "react";

export const BooleanInspector = genericMemo(function BooleanInspector({
  schema,
  expression,
  setExpression,
}: {
  schema: Schema;
  expression: DeepPartialExcept<BooleanEvaluationExpression, "field">;
  setExpression: (expression: DeepPartial<BooleanEvaluationExpression>) => void;
}) {
  const { t } = useTranslation();
  const booleanOptions: TextRedoListItem<boolean>[] = [
    { id: "true", type: "text", text: t("True"), value: true },
    { id: "false", type: "text", text: t("False"), value: false },
  ];

  useEffect(() => {
    if (!expression.type) {
      setExpression({ ...expression, type: "boolean_evaluation" });
    }
    // FIXME
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expression]);

  // May seem funny to return nothing. The useEffect above is the main point of this component.
  // But it is conceivable that this component could be expanded in the future, like with an "invert" toggle
  return (
    <RedoSingleSelectDropdownInput<boolean>
      label={t("Boolean match type")}
      options={booleanOptions}
      optionSelected={({ item: value }) => {
        setExpression({ ...expression, value: value.value });
      }}
      selectedItem={booleanOptions.find(
        (option) => option.value === (expression.value ?? true),
      )}
      size="xs"
    />
  );
});
